import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { ClientRoutingModule } from '@pg-app/client/client-routing.module';
import { ChangePasswordModule } from '@pg-app/common/change-password/change-password.module';
import { ChangeMemorableNumberModule } from '@pg-app/common/change-memorable-number/change-memorable-number.module';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { ApprovedPayersModule } from './approved-payers/approved-payers.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, ClientRoutingModule, CoreMaterialModule, CoreUiModule, NgTableModule,
    ChangePasswordModule, ChangeMemorableNumberModule, PipeModule, ApprovedPayersModule],
  declarations: [],
})
export class ClientModule { }
